import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { withNamespaces, Trans } from 'react-i18next';
import { Link } from 'core/routing';
import styled from 'styled-components';

import { media } from 'legacyComponents/styled/styleUtils';
import { Avatar } from 'components';
import Icon from 'components/Icon';

@withNamespaces()
@observer
export class MenuOption extends React.Component {
  @observable iconOverride = '';

  @action handleMouseEnter = () => {
    this.iconOverride = 'arrow_right';
  };

  @action handleMouseLeave = () => {
    this.iconOverride = '';
  };

  render() {
    const { onclick, id, linkName, linkParams, externalLink } = this.props;
    const { icon, color, img, title, count, description } = this.props;
    const linkProps = linkName
      ? { name: linkName, params: linkParams || {} }
      : {};
    const extLinkProps = externalLink
      ? { href: externalLink, target: '_blank', rel: 'noopener' }
      : {};
    const Component = linkName ? Link : externalLink ? 'a' : 'div';
    return (
      <MenuOptionStyled
        onClick={e => {
          onclick(e);
        }}
        onMouseEnter={() => this.handleMouseEnter()}
        onMouseLeave={() => this.handleMouseLeave()}
        id={id}
      >
        <Component {...linkProps} {...extLinkProps}>
          <Wrapper color={color}>
            <IconStyled
              name={this.iconOverride || icon}
              title={title}
              size='large'
              stroke='regular'
            />
            {img ? <Avatar src={img.avatar?.url} name={title} /> : null}
            <TextWrapper>
              <Title>
                <Trans>{title}</Trans> {count ? <Count>({count})</Count> : null}
              </Title>
              <Description>
                <Trans>{description}</Trans>
              </Description>
            </TextWrapper>
          </Wrapper>
        </Component>
      </MenuOptionStyled>
    );
  }
}

const MenuOptionStyled = styled.div`
  margin: 0 -${props => props.theme.spacing.large};
`;

export const Wrapper = styled.div`
  display: flex;
  ${media.s`
    width: 100%;
  `}
  margin: ${props => props.theme.spacing.xsmall} auto;
  height: 80px;
  padding: 0 ${props => props.theme.spacing.large} 0 8rem;
  align-items: center;
  &:hover {
    /* background-color: ${props => props.theme.color.wfBlue}; */
    cursor: pointer;
    > div > h2 {
      color: ${props => props.theme.color.primary};
    }
  }
  ${media.m`
    padding: 0 ${props => props.theme.spacing.large} 0 4rem
  `}
`;

const IconStyled = styled(Icon)`
  transition: margin-left 200ms ease-in-out;
  color: ${props => props.theme.color.wfBlack};
  ${Wrapper}:hover & {
    margin-left: ${props => props.theme.spacing.default};
    color: ${props => props.theme.color.wfBlue};
  }
`;

export const Title = styled.h2`
  font-weight: ${props => props.theme.font.weight.xbold};
  color: ${props => props.theme.color.wfBlack};
  margin-bottom: ${props => props.theme.spacing.small};
  font-size: 1.3rem;
  ${Wrapper}:hover & {
    /* color: ${props => props.theme.color.wfWhite}; */
  }
`;

export const TextWrapper = styled.div`
  max-width: 515px;
  margin-left: 2rem;
  transition: margin-left 200ms ease-in-out;
  ${media.xs`
    margin-left: 0;
    padding-left: 10px;
  `}
`;

export const Count = styled.span`
  color: ${props => props.theme.color.wfGrey200};
`;

export const Description = styled.h3`
  font-size: 0.9rem;
  font-weight: ${props => props.theme.font.weight.regular};
  color: ${props => props.theme.color.wfGrey900};
  line-height: 1.4;
  ${Wrapper}:hover & {
    /* color: ${props => props.theme.color.wfWhite}; */
  }
`;

MenuOption.propTypes = {
  onclick: PropTypes.func,
  selectTemplate: PropTypes.func,
  id: PropTypes.string,
  linkName: PropTypes.string,
  linkParams: PropTypes.object,
  externalLink: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  img: PropTypes.string,
  title: PropTypes.string,
  shortcut: PropTypes.string,
  count: PropTypes.number,
  description: PropTypes.string,
  template: PropTypes.object,
};
